
$(function () {
  // 商品チェック履歴
  if ($('#sysMypageAshiato').length >= 1) {
    $('#sysMypageAshiato .sysList form').each( function() {
      if ($(this).find('input[value="バリエーション選択"]').length >= 1) {
        $(this).find('input[value="バリエーション選択"]').remove();
        $(this).append('<button name="submit" type="submit" value="バリエーション選択" class="c-button-basic -sp-full -bg-black -no-icon _mt-20">バリエーション選択</button>');
      }
      if ($(this).find('input[value="カートに入れる"]').length >= 1) {
        $(this).find('input[value="カートに入れる"]').remove();
        $(this).append('<button name="submit" type="submit" value="カートに入れる" class="c-button-basic -sp-full -bg-black _mt-20">カートに入れる<svg class="c-button-basic__icon" width="27" height="27"><use xlink:href="#ico_cart_btn"></use></svg></button>');
      }
    });
  }
  // お気に入り
  if ($('#sysMypageReview').length >= 1) {
    $('#sysMypageReview .sysList form').each(function () {

      if ($(this).find('input[value="バリエーション選択"]').length >= 1) {
        $(this).find('input[value="バリエーション選択"]').remove();
        $(this).append('<button name="submit" type="submit" value="バリエーション選択" class="c-button-basic -sp-full -bg-black -no-icon _mt-20">バリエーション選択</button>');
      }
      if ($(this).find('input[value="カートに入れる"]').length >= 1) {
        $(this).find('input[value="カートに入れる"]').remove();
        $(this).append('<button name="submit" type="submit" value="カートに入れる" class="c-button-basic -sp-full -bg-black _mt-20">カートに入れる<svg class="c-button-basic__icon" width="27" height="27"><use xlink:href="#ico_cart_btn"></use></svg></button>');
      }
      if ($(this).find('input[value="お気に入りから削除する"]').length >= 1) {
        $(this).find('input[value="お気に入りから削除する"]').addClass('wish-no');
      }
    });
  }
});
